import React from "react";

function Map() {
  return (
    <>
      <div className="map fix" style={{ background: "#f5f5f5" }}>
        <div className="container-flud">
          <div className="row">
            <div className="col-lg-12">
              <iframe
                title="Mapa Fakulteta za poslovnu ekonomiju i pravo u Baru"
                src="https://maps.google.com/maps?width=600&amp;height=400&amp;hl=en&amp;q=fakultet za poslovnu ekonomiju i pravo&amp;t=&amp;z=16&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
                width={600}
                height={450}
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Map;
